



















































import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import storeHelper from "@/store/store-helper";
import { ConfirmationParameters } from "@/store/modules/readList/read-list";
import ReadNextDocument from "@/components/modules/document/ReadNextDocument.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import { ReadConfirmation } from "@infoland/iprova-api";
import Reason from "@/components/dialogs/Reason.vue";
import ConfirmReading from "@/components/dialogs/ConfirmReading.vue";
import { SnackBarTimeout } from "@/enums";
import i18n from "@/plugins/i18n";

export default Vue.extend({
    name: "ReadConfirmationAction",
    components: { DocumentToolbarAction, ReadNextDocument, ZenyaDialog, ConfirmReading, Reason },
    props: {
        documentId: String,
        isButton: Boolean,
        readConfirmationId: Number,
        enable: { default: true },
        documentName: String
    },
    data: function () {
        return {
            showReadNextDocumentDialog: false,
            readConfirmed: false,
            isReadConfirmationIrrelevantToMeEnabled: false,
            showReadConfirmationDialog: false,
            showReasonDialog: false,
            readButtonText: String,
            titleNextReadConfirmation: ""
        };
    },
    watch: {
        showReadNextDocumentDialog: function () {
            storeHelper.siteStore.setIsDialogDisplayed(this.showReadNextDocumentDialog);
        }
    },
    async created() {
        this.isReadConfirmationIrrelevantToMeEnabled = await storeHelper.settingsStore.getSettingAsync<boolean>(
            "read_confirmation_irrelevant_to_me_enabled"
        );
    },
    methods: {
        async confirmReadingAsync(): Promise<void> {
            if (this.isReadConfirmationIrrelevantToMeEnabled) {
                this.showReadConfirmationDialog = true;
            } else {
                await this.confirmAsync();
            }
        },

        async confirmAsync(): Promise<void> {
            let result = await storeHelper.readListStore.updateReadConfirmation({
                read_confirmation_id: this.readConfirmationId,
                document: {
                    document_id: this.documentId
                },
                confirmed: true
            } as ConfirmationParameters);

            if (result.success) {
                this.showReadNextDocumentDialogOrGoToTasksAsync(false);
            } else {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.error").toString(), true);
            }
        },

        showReadNextDocumentDialogOrGoToTasksAsync(documentIsNotApplicable: boolean): void {
            this.titleNextReadConfirmation = documentIsNotApplicable
                ? this.$t("document.readDocument.notApplicableConfirmation").toString()
                : this.$t("document.readDocument.confirmRead").toString();
            this.closeReasonDialog();
            let readList: ReadConfirmation[] = storeHelper.readListStore.list;
            //[DF-64285] make sure we return to tasks list when there are no documents left to read to prevent dialog issue
            if (
                readList == null ||
                readList.length === 0 ||
                (readList.length === 1 && readList[0].document.document_id === this.documentId) ||
                readList.findIndex(c => c.confirmed == false) < 0
            ) {
                if (documentIsNotApplicable) {
                    storeHelper.siteStore.setSnackBarMessage(
                        this.$t("document.readDocument.notApplicableConfirmation").toString(),
                        false,
                        SnackBarTimeout.short
                    );
                }
                this.$router.push({ name: "Tasks" });
            } else {
                this.showReadNextDocumentDialog = true;
            }
        },

        manageDialogs(value: boolean): void {
            this.showReadConfirmationDialog = value;
            this.showReasonDialog = !value;
        },

        closeReadConfirmationDialog(): void {
            this.showReadConfirmationDialog = false;
        },

        closeReasonDialog(): void {
            this.showReasonDialog = false;
        }
    }
});
